export default {
  'Custom': '자정',
  'Original': '원본',
  'Resolution': '해상도',
  'Frame rate': '프레임률',
  'The higher the frame rate, the smoother the animation': '프레임률이 높을수록 애니메이션이 매끄러워집니다.',
  'Start': '시작',
  'End': '종료',
  'Create GIF': 'GIF 생성하기',
  'Download GIF': 'GIF 다운로드',
  'Create A New One': '새로운것 만들기 ',
  'Remake GIF': 'GIF 다시 만들기',
  'HitPaw Video to GIF Online': 'HitPaw온라인으로 비디오를 GIF로 변환기',
  'Upload and convert video to GIF without any difficulty': '어렵지 않게 동영상을 GIF로 업로드 및 변환합니다.',
}